"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.joinFilterQuery = void 0;
const joinFilterQuery = (filterQuery, conjunction) => {
    if (filterQuery.length < 2) {
        return filterQuery.join(` ${conjunction} `);
    }
    return filterQuery
        .filter((query) => Boolean(query))
        .map(filter => {
        if (/\(|\)/.test(filter) || !/(AND|OR)/.test(filter)) {
            return filter;
        }
        return `(${filter})`;
    })
        .join(` ${conjunction} `);
};
exports.joinFilterQuery = joinFilterQuery;
//# sourceMappingURL=joinFilterQuery.js.map